import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getYearlyOccupationTrend = async (HubIds: string[], ISICCodes: string[], ISCO2Codes: string[], fromQuarter?: string, Locations?: string[], isEntryLevel?: boolean) => {
    const { path, method } = endpoints.occupationAndSector.getYearlyOccupationTrend;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}`,
        method,
        { HubIds, ISICCodes, ISCO2Codes, fromQuarter, Locations, isEntryLevel },
        {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
